import React from 'react';
import {Image} from "@chakra-ui/react";
import {IDevice} from "../../mocks/sessionsDevicesItems.tsx";

interface SessionDeviceProps {
  item: IDevice;
}

const SessionDevice: React.FC<SessionDeviceProps> = ({item}: SessionDeviceProps) => (
  <div className="flex items-start py-6 border-t border-n-300 dark:border-n-600">
    <div className="flex justify-center items-center shrink-0 w-12 h-12 mr-4 px-2 bg-n-300 rounded-xl dark:bg-n-500">
      <Image
        className="w-full"
        src={item.image}
        width={32}
        height={32}
        alt=""
      />
    </div>
    <div className="grow">
      <div className="mb-1 base1 font-semibold text-n-600 dark:text-n-300">
        {item.title}
      </div>
      <div className="base2 text-n-400">
        <p>{item.address}</p>
        <p>{item.date}</p>
      </div>
    </div>
    <button className="btn-stroke-light shrink-0 ml-4">Revoke</button>
  </div>
);

export default SessionDevice;
